import type { ReactNode } from 'react';

// Example:
//   header: headerWithTooltip('Positional Index', () => (
//     <span>Positional Index <Information /></span>
//   ))

/**
 * Wraps a DataTable column-header render function with a custom `toString()`
 * so the Column Visibility panel (which reads
 * `column.columnDef.header?.toString()` for its toggle labels) shows a
 * plain-text label instead of the stringified function source.
 * @param {string} label - Plain-text column name shown in the visibility panel.
 * @param {Function} render - Render function returning the JSX header.
 * @return {Function} The render function with a custom `toString()`.
 */
export function headerWithTooltip(
  label: string,
  render: () => ReactNode
): () => ReactNode {
  const fn = render as typeof render & { toString: () => string };
  fn.toString = () => label;
  return fn;
}
